enum BitePlatform {
  KioskIos = 'kiosk-ios',
  KioskAndroid = 'kiosk-android',
  KioskIosGarcon = 'kiosk-ios-garcon',
  KioskAndroidGarcon = 'kiosk-android-garcon',
  KioskSignageOsGarcon = 'kiosk-signageos-garcon',
  KioskChromeOsGarcon = 'kiosk-chromeos-garcon',
  Flash = 'flash',
}

export { BitePlatform };
